import React, { useRef, useState, useEffect } from "react";
import { motion } from "framer-motion";
import YAxis from "./YAxis";
import Grid from "./Grid";
import Bars from "./Bars";
import XAxis from "./XAxis";

//---------------- Y Axis ----------------
// const YAxis = ({ ticks, onWidthChange, formatTick }) => {
//   const ref = useRef(null);

//   useEffect(() => {
//     if (!ref.current) return;
//     const observer = new ResizeObserver(() => {
//       if (ref.current) {
//         onWidthChange(ref.current.offsetWidth);
//       }
//     });
//     observer.observe(ref.current);
//     return () => observer.disconnect();
//   }, [onWidthChange]);

//   return (
//     <div
//       ref={ref}
//       className="flex flex-col-reverse justify-between items-end h-full pr-2"
//     >
//       {ticks.map((t, i) => (
//         <span key={i} className="text-xs text-gray-600 whitespace-nowrap">
//           {formatTick ? formatTick(t) : t}
//         </span>
//       ))}
//     </div>
//   );
// };

// // ---------------- X Axis ----------------
// const XAxis = ({ labels, marginLeft, formatTick, barPositions }) => (
//   <div className="relative min-h-5" style={{ marginLeft }}>
//     {barPositions.map((pos, i) => (
//       <span
//         key={i}
//         className="absolute text-xs text-gray-600 font-medium whitespace-nowrap text-center"
//         style={{
//           left: pos.left - barPositions[0].left,
//           width: pos.width,
//         }}
//       >
//         {formatTick ? formatTick(labels[i]) : labels[i]}
//       </span>
//     ))}
//   </div>
// );

// // ---------------- Grid (Horizontal + Vertical) ----------------
// const Grid = ({ ticks, columns, showHorizontal, showVertical }) => (
//   <>
//     {showHorizontal && (
//       <div className="absolute inset-0 flex flex-col justify-between">
//         {ticks.map((_, i) => (
//           <div
//             key={`h-${i}`}
//             className="border-t border-dashed border-gray-300 w-full"
//           />
//         ))}
//       </div>
//     )}

//     {showVertical && (
//       <div className="absolute inset-0 flex">
//         {Array.from({ length: columns }).map((_, i) => (
//           <div key={`v-${i}`} className="flex-1 flex justify-center">
//             <div className="border-l border-dashed border-gray-300 h-full" />
//           </div>
//         ))}
//       </div>
//     )}
//   </>
// );

// // ---------------- Value Label ----------------
// const ValueLabel = ({ value, barHeight, color }) => (
//   <motion.div
//     initial={{ opacity: 0, y: 10 }}
//     animate={{ opacity: 1, y: 0 }}
//     transition={{ duration: 0.6, ease: "easeOut", delay: 0.4 }} // delay so it appears after bar grows
//     className={`absolute bg-${color}-50 border border-${color} text-${color} px-2 rounded text-xs font-medium mb-2`}
//     style={{
//       bottom: `${barHeight}%`,
//     }}
//   >
//     {value}
//   </motion.div>
// );

// // ---------------- Bars ----------------
// const Bars = ({
//   data,
//   maxValue,
//   showValueLabel,
//   barWidth,
//   barRadius,
//   defaultColor,
//   defaultDepth,
//   onBarPositions,
// }) => {
//   const barRefs = useRef([]);

//   useEffect(() => {
//     if (!barRefs.current.length) return;

//     const updatePositions = () => {
//       const positions = barRefs.current.map((ref) => {
//         if (!ref) return { left: 0, width: 0 };
//         const rect = ref.getBoundingClientRect();
//         return { left: rect.left, width: rect.width };
//       });
//       onBarPositions(positions);
//     };

//     updatePositions(); // ✅ run immediately

//     const observer = new ResizeObserver(() => updatePositions()); // ✅ observe resize
//     barRefs.current.forEach((ref) => ref && observer.observe(ref));

//     return () => observer.disconnect(); // ✅ cleanup
//   }, [data, barWidth, onBarPositions]); // no change here

//   return (
//     <div className="flex justify-around items-end w-full h-full relative z-10 gap-2">
//       {data.map((item, i) => {
//         const heightPercent = (item.value / maxValue) * 100;
//         const barColor = `bg-${item.color || defaultColor}-${
//           item.depth || defaultDepth
//         }`;

//         return (
//           <div
//             key={i}
//             ref={(el) => (barRefs.current[i] = el)}
//             className="relative flex flex-col items-center h-full justify-end flex-1"
//           >
//             <motion.div
//               className={`${barColor}`}
//               style={{
//                 width: barWidth,
//                 borderTopLeftRadius: barRadius,
//                 borderTopRightRadius: barRadius,
//               }}
//               initial={{ height: 0 }}
//               animate={{ height: `${heightPercent}%` }}
//               transition={{ duration: 0.8, ease: "easeOut" }}
//             />
//             {showValueLabel && (
//               <ValueLabel
//                 value={item.value}
//                 barHeight={heightPercent}
//                 color={item.color || defaultColor}
//               />
//             )}
//           </div>
//         );
//       })}
//     </div>
//   );
// };

// ---------------- Main Chart ----------------
const BarChart = ({
  data,
  steps = 5,
  showHorizontalGrid = true,
  showVerticalGrid = true,
  showValueLabel = true,
  barWidth = "48px",
  barRadius = "8px",
  formatYAxisTick,
  formatXAxisTick,
  color = "primary",
  backgroundColor = "bg-white",
  depth = 500,
}) => {
  const [yAxisWidth, setYAxisWidth] = useState(0);
  const [barPositions, setBarPositions] = useState([]);

  // const maxValue = Math.max(...data.map((d) => d.value));
  // const step = Math.ceil(maxValue / steps + 1);
  // const ticks = Array.from({ length: steps + 1 }, (_, i) => step * i);

  // console.log("maxValue: ", maxValue, steps, ticks);

  // const maxValue = Math.max(...data.map((d) => d.value));
  // const step = maxValue / (steps - 1);
  // const ticks = Array.from(
  //   { length: steps + 1 },
  //   (_, i) => +(step * i).toFixed(2)
  // );

  const maxValue = Math.max(...data.map((d) => d.value));
  const safeMax = maxValue === 0 ? 1 : maxValue; // Prevent divide-by-zero
  const step = safeMax / (steps - 1);
  const ticks = Array.from(
    { length: steps + 1 },
    (_, i) => +(step * i).toFixed(2)
  );
  const maxTick = step * steps;

  return (
    <div className={`flex-1 flex flex-col overflow-x-auto`}>
      <div className="flex flex-1">
        <YAxis
          ticks={ticks}
          onWidthChange={setYAxisWidth}
          formatTick={formatYAxisTick}
        />

        <div
          className={`relative flex-1 ${backgroundColor} border border-gray-300 rounded-lg flex items-end`}
        >
          <Grid
            ticks={ticks}
            columns={data.length}
            showHorizontal={showHorizontalGrid}
            showVertical={showVerticalGrid}
          />
          <Bars
            data={data}
            maxValue={ticks[ticks.length - 1]}
            showValueLabel={showValueLabel}
            barWidth={barWidth}
            barRadius={barRadius}
            defaultColor={color}
            defaultDepth={depth}
            onBarPositions={setBarPositions}
          />
        </div>
      </div>

      <XAxis
        labels={data.map((d) => d.label)}
        marginLeft={yAxisWidth}
        formatTick={formatXAxisTick}
        barPositions={barPositions}
      />
    </div>
  );
};

export default BarChart;
